
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","transform":"scale(-1 1)"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 10.308v4.93h3.556v-4.93c0-3.707 3.389-6.723 7.555-6.723H16V0h-4.889C4.984 0 0 4.624 0 10.308z"}})])
          )
        }
      }
    